<template>
  <div class="dashboard-cost-forecast">
    <h3 class="forecast-title">
      <v-icon small color="#FF5722">mdi-chart-timeline-variant</v-icon>
      {{ $t('org-dashboard.cost-forecast') }}
    </h3>

    <div class="forecast-cards">
      <div class="forecast-card">
        <div class="forecast-card-label">{{ $t('org-dashboard.monthly-run-rate') }}</div>
        <div class="forecast-card-value">{{ formatValue(monthlyRunRate) }} <span class="forecast-card-suffix">/{{ $t('org-dashboard.month-short') || 'mois' }}</span></div>
      </div>
      <div class="forecast-card">
        <div class="forecast-card-label">{{ $t('org-dashboard.annual-forecast') }}</div>
        <div class="forecast-card-value">{{ formatValue(annualForecast) }} <span class="forecast-card-suffix">/{{ $t('org-dashboard.year-short') || 'an' }}</span></div>
      </div>
      <div class="forecast-card">
        <div class="forecast-card-label">{{ $t('org-dashboard.spent-period', { days: periodDays }) }}</div>
        <div class="forecast-card-value">{{ formatValue(spent) }}</div>
      </div>
    </div>

    <p class="forecast-disclaimer">{{ $t('org-dashboard.forecast-disclaimer') }}</p>
  </div>
</template>

<script>
export default {
  name: 'DashboardCostForecast',
  props: {
    monthlyRunRate: { type: Number, default: null },
    annualForecast: { type: Number, default: null },
    spent: { type: Number, default: null },
    periodDays: { type: Number, default: 30 },
    currency: { type: String, default: 'EUR' },
  },

  methods: {
    formatValue(val) {
      if (val === null || val === undefined) return '--'
      return new Intl.NumberFormat(this.$i18n.locale, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: 0,
      }).format(val)
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-cost-forecast {
  background: white;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.forecast-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
}

.forecast-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.forecast-card {
  padding: 16px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  text-align: center;
}

.forecast-card-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #6b7280;
  margin-bottom: 8px;
}

.forecast-card-value {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
}

.forecast-card-suffix {
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
}

.forecast-disclaimer {
  margin-top: 16px;
  font-size: 11px;
  color: #9ca3af;
  text-align: center;
  font-style: italic;
}

@media (max-width: 768px) {
  .forecast-cards {
    grid-template-columns: 1fr;
  }
}
</style>
